export default __webpack_public_path__ + "static/derrick-0057cebdfe5b2316829262c006d544e2.png";